<template>
    <div class="mt-4">
        <el-row>
            <el-col :span="24" class="text-center">
                <div class="view-title">Nueva Pastelería</div>
            </el-col>
        </el-row>

        <el-row class="mt-3 px-5 py-4 bg-white border border-gray rounded">
            <el-col>

                <el-row class="mb-3">
                    <el-col :span="1">
                        <i v-if="role === 'ADMIN'" class="el-icon-close icon-gray cursor-pointer" @click="exit"></i>
                        <div v-else >&nbsp;</div>
                    </el-col>

                    <el-col :span="4" :offset="9">
                        <el-steps :active="currentStep" finish-status="success">
                            <el-step></el-step>
                            <el-step></el-step>
                            <el-step></el-step>
                        </el-steps>
                    </el-col>
                </el-row>

                <cakeshops-new-step-one
                    v-if="currentStep===0"
                    @next-step="stepOneFinished"
                    @save-draft="goBack"/>

                <cakeshops-new-step-two
                    title="Primera Creación"
                    v-else-if="currentStep===1"
                    :cakeshop-uuid="cakeshop.uuid"
                    @next-step="stepTwoFinished"
                    @save-draft="goBack"/>

                <cakeshops-new-step-three
                    v-else-if="currentStep===2"
                    :cakeshop-uuid="cakeshop.uuid"
                    :cake-uuid="cakeshop.cake.uuid"
                    :initial-cake-customizations="cakeshop.cake.customizations"
                    :initial-cake-fillings="cakeshop.cake.fillings"
                    :initial-cake-flours="cakeshop.cake.flours"
                    :initial-cake-toppings="cakeshop.cake.toppings"
                    :initial-cake-sweeteners="cakeshop.cake.sweeteners"
                    :purchasable="cakeshop.cake.purchasable"
                    @save-draft="goBack"
                    @published="cakeshopPublished"/>

            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {messages, dialogs} from '../../../constants/text-constants';
    import {mapGetters} from 'vuex';
    import {activateCakeshop} from '../../../api/cakeshop-api'
    import CakeshopsNewStepOne from './components/CakeshopsNewStepOne';
    import CakeshopsNewStepTwo from './components/CakeshopsNewStepTwo';
    import CakeshopsNewStepThree from './components/CakeshopsNewStepThree';

    export default {
        name: "CakeshopNew",
        components: {
            CakeshopsNewStepOne,
            CakeshopsNewStepTwo,
            CakeshopsNewStepThree
        },
        data() {
            return {
                currentStep: 0,
                cakeshop: {
                    uuid: null,
                    cake: {
                        uuid: null,
                        purchasable: true,
                        customizations: [],
                        fillings: [],
                        flours: [],
                        toppings: [],
                        sweeteners: [],
                    }
                }
            }
        },
        methods: {
            stepOneFinished(cakeshop) {
                this.cakeshop.uuid = cakeshop.uuid;
                this.nextStep();
            },
            stepTwoFinished(cake) {
                this.cakeshop.cake.uuid = cake.uuid;
                this.cakeshop.cake.purchasable = cake.purchasable;
                this.cakeshop.cake.customizations = cake.customizations;
                this.cakeshop.cake.fillings = cake.fillings;
                this.cakeshop.cake.flours = cake.flours;
                this.cakeshop.cake.toppings = cake.toppings;
                this.cakeshop.cake.sweeteners = cake.sweeteners;
                this.nextStep();
            },
            nextStep() {
                this.currentStep++;
            },
            exit() {
                this.$confirm(dialogs.cakeshop.cancelWizard.text, {
                    confirmButtonText: dialogs.cakeshop.cancelWizard.confirm,
                    cancelButtonText: dialogs.cakeshop.cancelWizard.cancel,
                }).then(() => {
                    this.goBack();
                }).catch(() => {});
            },
            cakeshopPublished() {
                activateCakeshop(this.cakeshop.uuid).then(() => {
                    this.$message.success(messages.cakeshop.create.success);
                    this.goBack();
                });
            },
            goBack() {
                if (this.role === 'BAKER') {
                    this.$router.push({name: 'baker-check'})
                } else {
                    this.$router.push({name: 'cakeshops-list'})
                }
            }
        },
        computed: {
            ...mapGetters([
                'role',
            ]),
        }
    }
</script>

<style scoped>
    .el-icon-close {
        font-size: 18px;
    }
</style>
